const product_CN_Locale = {
    'product.text_title1': '全栈式智能',
    'product.text_title2': '超声解决方案',
    'product.text_title3': '',
    'product.swiperCenter1_1': '专业标注',
    'product.swiperCenter1_2': '高效便捷',
    'product.swiperCenter2_1': '形影不离',
    'product.swiperCenter2_2': '智AI新生',
    'product.swiperCenter3_1': '智敬女性',
    'product.swiperCenter4_1': '医技帮手',
    'product.swiperCenter4_2': '请多智教',
    'product.swiperCenter5_1': '火眼金睛',
    'product.swiperCenter5_2': '无 “结” 可藏',
    'product.swiperCenter6_1': '为你的健康',
    'product.swiperCenter6_2': '保驾护航',
    'product.swiperCenter7_1': '不止心动',
    'product.swiperCenter7_2': 'AI拥抱爱',
    'product.swiperCenter8_1': '智绘孕育',
    'product.swiperCenter8_2': '助力未来',
    'product.swiperCenter9_1': '超声质控',
    'product.swiperCenter9_2': '数智化赋能',
    'product.menuTitle1': '一站式医学影像智能标注软件',
    'product.menuTitle2': '产前智能超声筛查系统',
    'product.menuTitle3': '盆底智能超声筛查系统',
    'product.menuTitle4': '婴幼儿髋关节智能超声影像处理系统',
    'product.menuTitle5': '乳腺超声辅助筛查系统',
    'product.menuTitle6': '甲状腺超声辅助筛查评估系统',
    'product.menuTitle7': '心脏超声智能辅助筛查系统',
    'product.menuContent7': '心脏智能超声辅助筛查系统',
    'product.menuTitle8': '辅助生殖自动测量系统',
    'product.menuContent8': '辅助生殖智能超声辅助筛查系统',
    'product.menuTitle9': '智能超声质控平台',

}
export default product_CN_Locale
